import { z } from "zod";
import { AwCompanyIdSchema } from "types/src/traits";

export const AbstractExtractSchema = AwCompanyIdSchema
	.merge(z.object({}));

export type AbstractExtract = z.infer<typeof AbstractExtractSchema>

